import { createStyles, makeStyles } from "@material-ui/core";
import { RelodeTheme } from "@relode/core";
import * as React from "react";

const usePageHeaderStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            root: {
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                minHeight: theme.spacing(12),
                marginRight: theme.spacing(2),
                [theme.breakpoints.down("sm")]: {
                    marginTop: theme.spacing(2),
                    marginBottom: theme.spacing(1),
                    marginRight: "unset",
                    minHeight: theme.spacing(8),
                    alignItems: "flex-start",
                    flexDirection: "column",
                    WebkitOverflowScrolling: "touch", // Add iOS momentum scrolling.
                },
            },
        }),
    { name: "PageHeader" }
);

export const PageHeader = (props: { children: React.ReactNode }) => {
    const classes = usePageHeaderStyles({});
    return <div className={classes.root}>{props.children}</div>;
};
